// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import { LEGAL_DOCS as DOCS } from './legal/LegalLayout';
// import CookieBanner from '../CookieBanner';

// const SECTIONS = [
//   {
//     id: 'smtp',
//     title: '📧 Где брать SMTP-почты',
//     blocks: [
//       {
//         heading: 'Что такое SMTP и зачем он нужен',
//         text: 'SMTP — это корпоративный почтовый аккаунт, с которого будут уходить ваши письма. Лучше использовать 5–10-100 разных ящиков, чтобы распределять нагрузку и не попадать в спам.',
//       },
//       {
//         heading: 'Где взять почты для рассылок',
//         list: [
//           'Купить 1-2-3 домена на (reg.ru, nic.ru) — например, mycompany.ru. Либо может у вас уже есть купленный домен',
//           'Настроить почту на купленном домене: через Яндекс 360, Mail.ru для бизнеса, Google Workspace, Reg.ru',
//           'Создать 5 email ящиков на 1 домен: anna@mycompany.ru, ivan@mycompany.ru и т.д.',
//           'Подключить в Mailora: раздел «Почты» → «Добавить SMTP».',
//         ],
//       },
//       {
//         heading: 'Что важно',
//         list: [
//           'Не используйте личную почту (gmail.com, yandex.ru, mail.ru) для рассылок — вы быстро улетите в спам и эффекта никакого не будет',
//           'Обязательно настройте SPF, DKIM, DMARC для купленного домена — иначе письма не дойдут.',
//           'Начните с 5–10 писем в день на ящик, постепенно увеличивайте - тем самым делая безопасный прогрев для почт. Рекомендуется для новых почт делать 2-х недельный прогрев',
//         ],
//       },
//     ],
//   },
//   {
//     id: 'contacts',
//     title: '👥 Где брать контакты и ЛПР',
//     blocks: [
//       {
//         heading: 'Кто такой ЛПР',
//         text: 'ЛПР — лицо, принимающее решение. Это человек, который может согласовать сделку: директор, маркетолог, руководитель отдела. Писать нужно именно им, а не на общий info@.',
//       },
//       {
//         heading: 'Откуда брать базы',
//         list: [
//           'Открытые каталоги: 2GIS, Яндекс.Карты, Rusprofile, Контур, Спарк.',
//           'Профессиональные соцсети: LinkedIn (для B2B), Habr (для IT), VK-сообщества.',
//           'Сайты компаний: раздел «Контакты» и «Команда».',
//           'Отраслевые каталоги и выставки: участники конференций — отличная база ЛПР.',
//           'Своя история: клиенты, которые уже покупали, отвалившиеся лиды, рефералы.',
//         ],
//       },
//       {
//         heading: 'Как загрузить в Mailora',
//         list: [
//           'Соберите базу в CSV с колонками: name, email, company, city.',
//           'Откройте раздел «Каталог баз» → «Создать базу» → «Импорт».',
//           'Проверьте email на валидность — иначе bounce-писем будет много.',
//           'Запустите кампанию и следите за ответами в разделе «Переписки».',
//         ],
//       },
//       {
//         heading: 'Совет',
//         text: 'Качество важнее количества. 100 точных контактов ЛПР дадут больше ответов, чем 10 000 случайных адресов.',
//       },
//     ],
//   },
//   {
//     id: 'letters',
//     title: '✍️ Как писать письма',
//     blocks: [
//       {
//         heading: 'Структура рабочего письма',
//         list: [
//           'Тема: короткая, до 50 символов. Без капса и «!!!». Например: «Идея для отдела маркетинга в Nordics».',
//           'Приветствие: по имени. «Привет, Анна!» работает лучше, чем «Здравствуйте!».',
//           'Персонализация: 1–2 предложения про компанию получателя — из его сайта или профиля.',
//           'Суть: что вы предлагаете и какую боль решаете. Конкретно, без воды.',
//           'Призыв: один простой вопрос. «Есть 15 минут на этой неделе?» — работает.',
//         ],
//       },
//       {
//         heading: 'Чего избегать',
//         list: [
//           'Длинных текстов — человек читает холодное письмо 3–5 секунд.',
//           'Ссылок на первый контакт — улетает в спам.',
//           'Слов «бесплатно», «акция», «скидка 90%» — за них банят.',
//           'Вложений в первом письме — тоже спам-фактор.',
//         ],
//       },
//       {
//         heading: 'Цепочка писем',
//         text: 'Одно письмо не работает. Делайте цепочку из 3–4 писем с интервалом 3–5 дней. Первое — знакомство, второе — кейс, третье — напоминание, четвёртое — «закрывающее» (предложение отстать).',
//       },
//     ],
//   },
//   {
//     id: 'campaigns',
//     title: '🚀 Как настроить рассылку в Mailora',
//     blocks: [
//       {
//         heading: 'Пошаговый запуск',
//         list: [
//           'Шаг 1. Подключите SMTP-почты: раздел «Почты».',
//           'Шаг 2. Загрузите базу контактов: раздел «Каталог баз».',
//           'Шаг 3. Перейдите в раздел «Рассылки» → «Создать кампанию».',
//           'Шаг 4. Выберите базу контактов и SMTP-аккаунты (можно несколько).',
//           'Шаг 5. Напишите тему и текст письма. Используйте переменную {{name}}/{{companyName}}/{{city}} для персонализации.',
//           'Шаг 6. Настройте цепочку: добавьте 2–3 письма с задержкой 3–5 дней.',
//           'Шаг 7. Запустите. Статус и статистика — в дашборде.',
//         ],
//       },
//       {
//         heading: 'Как следить за результатом',
//         list: [
//           'Дашборд: отправлено, ответов.',
//           'Переписки: все ответы собираются в единый инбокс.',
//         ],
//       },
//       {
//         heading: 'Безопасный режим отправки',
//         list: [
//           '5–10-20 писем в день на один ящик в первые 2 недели.',
//           'Не запускайте кампанию на 1000+ писем сразу.',
//           'Если получили жалобу — сразу удалите контакт из базы.',
//         ],
//       },
//     ],
//   },
// ];

// export default function HelpPage() {
//   const [activeSection, setActiveSection] = useState(SECTIONS[0].id);

//   return (
//     <div className="min-h-screen bg-gray-50 text-gray-900">
//       {/* Header */}
//       <header className="bg-white border-b border-gray-200 sticky top-0 z-40">
//         <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between">
//           <Link to="/" className="flex items-center gap-2 text-xl font-bold text-blue-600">
//             <span className="w-2 h-2 rounded-full bg-blue-600 inline-block" />
//             MAILORA
//           </Link>
//           <div className="flex gap-3">
//             <Link to="/login" className="px-4 py-2 rounded-xl text-gray-700 hover:bg-gray-100 transition">
//               Войти
//             </Link>
//             <Link to="/register" className="px-4 py-2 rounded-xl bg-blue-600 text-white hover:bg-blue-700 transition shadow-md">
//               Регистрация
//             </Link>
//           </div>
//         </div>
//       </header>

//       {/* Content */}
//       <main className="max-w-6xl mx-auto px-4 py-10">
//         <div className="mb-8">
//           <h1 className="text-3xl md:text-4xl font-bold">📚 Инструкция по работе с Mailora</h1>
//           <p className="mt-3 text-gray-600">
//             Как подключить почты, где взять контакты, как писать письма и запустить первую рассылку.
//           </p>
//         </div>

//         <div className="grid md:grid-cols-[260px_1fr] gap-6">
//           {/* Меню разделов */}
//           <aside className="bg-white rounded-2xl shadow-md p-2 h-fit md:sticky md:top-20">
//             {SECTIONS.map((s) => (
//               <button
//                 key={s.id}
//                 onClick={() => {
//                   setActiveSection(s.id);
//                   window.scrollTo({ top: 0, behavior: 'smooth' });
//                 }}
//                 className={`w-full text-left px-3 py-3 rounded-xl text-[14.5px] transition mb-1 ${
//                   activeSection === s.id
//                     ? 'bg-blue-50 text-blue-700 font-medium border-2 border-blue-500'
//                     : 'text-gray-600 hover:bg-gray-100 border-2 border-transparent'
//                 }`}
//               >
//                 {s.title}
//               </button>
//             ))}
//           </aside>

//           {/* Содержимое */}
//           <div className="bg-white rounded-2xl shadow-md p-8">
//             {SECTIONS.filter(s => s.id === activeSection).map(s => (
//               <div key={s.id}>
//                 <h2 className="text-2xl font-bold mb-6">{s.title}</h2>
//                 {s.blocks.map((b, i) => (
//                   <div key={i} className="mb-8 last:mb-0">
//                     <h3 className="text-lg font-semibold mb-3">{b.heading}</h3>
//                     {b.text && (
//                       <p className="text-[15px] text-gray-600 leading-relaxed">{b.text}</p>
//                     )}
//                     {b.list && (
//                       <ul className="space-y-2">
//                         {b.list.map((item, j) => (
//                           <li key={j} className="text-[15px] text-gray-700 pl-5 relative">
//                             <span className="absolute left-0 text-blue-600">•</span>
//                             {item}
//                           </li>
//                         ))}
//                       </ul>
//                     )}
//                   </div>
//                 ))}
//               </div>
//             ))}
//           </div>
//         </div>
//       </main>

//       {/* Футер */}
//       <footer className="bg-white border-t border-gray-200 py-12 mt-16">
//         <div className="max-w-6xl mx-auto px-4">
//           <div className="grid sm:grid-cols-3 gap-8">
//             <div>
//               <Link to="/" className="flex items-center gap-2 text-xl font-bold text-blue-600">
//                 <span className="w-2 h-2 rounded-full bg-blue-600 inline-block" />
//                 MAILORA
//               </Link>
//               <p className="mt-3 text-sm text-gray-500">Сервис для email-аутрича</p>
//             </div>
//             <div>
//               <h5 className="text-xs font-semibold uppercase tracking-wider text-gray-400 mb-4">Контакты</h5>
//               <a href="tel:+79054577889" className="block py-1.5 text-sm text-gray-600 hover:text-blue-600 transition">+7 (905) 457-78-89</a>
//               <a href="mailto:support@mailora.ru" className="block py-1.5 text-sm text-gray-600 hover:text-blue-600 transition">support@mailora.ru</a>
//             </div>
//             <div>
//               <h5 className="text-xs font-semibold uppercase tracking-wider text-gray-400 mb-4">Документы</h5>
//               {DOCS.map((doc) => (
//                 <a key={doc.path} href={doc.path} target="_blank" rel="noopener noreferrer"
//                    className="block py-1.5 text-sm text-gray-600 hover:text-blue-600 transition">
//                   {doc.label}
//                 </a>
//               ))}
//             </div>
//           </div>

//           <div className="border-t border-gray-200 mt-10 pt-6 text-[13px] text-gray-500">
//             <div className="flex flex-wrap gap-x-6 gap-y-1">
//               <span><span className="font-medium text-gray-700">ИП</span> Сидоренко Руслан Владимирович</span>
//               <span><span className="font-medium text-gray-700">ИНН</span> 611300126009</span>
//               <span><span className="font-medium text-gray-700">ОГРНИП</span> 317619600088799</span>
//             </div>
//             <div className="mt-4">© {new Date().getFullYear()} Mailora. Все права защищены.</div>
//           </div>
//         </div>
//       </footer>

//       <CookieBanner />
//     </div>
//   );
// }

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { LEGAL_DOCS as DOCS } from './legal/LegalLayout';
import CookieBanner from '../CookieBanner';

const SECTIONS = [
  {
    id: 'smtp',
    title: '📧 Где брать SMTP-почты',
    blocks: [
      {
        heading: 'Что такое SMTP и зачем он нужен',
        text: 'SMTP — это корпоративный почтовый аккаунт, с которого будут уходить ваши письма. Лучше использовать 5–10-100 разных ящиков, чтобы распределять нагрузку и не попадать в спам.',
      },
      {
        heading: 'Где взять почты для рассылок',
        list: [
          'Купить 1-2-3 домена на (reg.ru, nic.ru) — например, mycompany.ru. Либо может у вас уже есть купленный домен',
          'Настроить почту на купленном домене: через Яндекс 360, Mail.ru для бизнеса, Google Workspace, Reg.ru',
          'Создать 5 email ящиков на 1 домен: anna@mycompany.ru, ivan@mycompany.ru и т.д.',
          'Подключить в Mailora: раздел «Почты» → «Добавить SMTP».',
        ],
      },
      {
        heading: 'Что важно',
        list: [
          'Не используйте личную почту (gmail.com, yandex.ru, mail.ru) для рассылок — вы быстро улетите в спам и эффекта никакого не будет',
          'Обязательно настройте SPF, DKIM, DMARC для купленного домена — иначе письма не дойдут.',
          'Начните с 5–10 писем в день на ящик, постепенно увеличивайте - тем самым делая безопасный прогрев для почт. Рекомендуется для новых почт делать 2-х недельный прогрев',
        ],
      },
    ],
  },
  {
    id: 'contacts',
    title: '👥 Где брать контакты и ЛПР',
    blocks: [
      {
        heading: 'Кто такой ЛПР',
        text: 'ЛПР — лицо, принимающее решение. Это человек, который может согласовать сделку: директор, маркетолог, руководитель отдела. Писать нужно именно им, а не на общий info@.',
      },
      {
        heading: 'Откуда брать базы',
        list: [
          'Открытые каталоги: 2GIS, Яндекс.Карты, Rusprofile, Контур, Спарк.',
          'Профессиональные соцсети: LinkedIn (для B2B), Habr (для IT), VK-сообщества.',
          'Сайты компаний: раздел «Контакты» и «Команда».',
          'Отраслевые каталоги и выставки: участники конференций — отличная база ЛПР.',
          'Своя история: клиенты, которые уже покупали, отвалившиеся лиды, рефералы.',
        ],
      },
      {
        heading: 'Как загрузить в Mailora',
        list: [
          'Соберите базу в CSV с колонками: name, email, company, city.',
          'Откройте раздел «Каталог баз» → «Создать базу» → «Импорт».',
          'Проверьте email на валидность — иначе bounce-писем будет много.',
          'Запустите кампанию и следите за ответами в разделе «Переписки».',
        ],
      },
      {
        heading: 'Совет',
        text: 'Качество важнее количества. 100 точных контактов ЛПР дадут больше ответов, чем 10 000 случайных адресов.',
      },
    ],
  },
  {
    id: 'letters',
    title: '✍️ Как писать письма',
    blocks: [
      {
        heading: 'Структура рабочего письма',
        list: [
          'Тема: короткая, до 50 символов. Без капса и «!!!». Например: «Идея для отдела маркетинга в Nordics».',
          'Приветствие: по имени. «Привет, Анна!» работает лучше, чем «Здравствуйте!».',
          'Персонализация: 1–2 предложения про компанию получателя — из его сайта или профиля.',
          'Суть: что вы предлагаете и какую боль решаете. Конкретно, без воды.',
          'Призыв: один простой вопрос. «Есть 15 минут на этой неделе?» — работает.',
        ],
      },
      {
        heading: 'Чего избегать',
        list: [
          'Длинных текстов — человек читает холодное письмо 3–5 секунд.',
          'Ссылок на первый контакт — улетает в спам.',
          'Слов «бесплатно», «акция», «скидка 90%» — за них банят.',
          'Вложений в первом письме — тоже спам-фактор.',
        ],
      },
      {
        heading: 'Цепочка писем',
        text: 'Одно письмо не работает. Делайте цепочку из 3–4 писем с интервалом 3–5 дней. Первое — знакомство, второе — кейс, третье — напоминание, четвёртое — «закрывающее» (предложение отстать).',
      },
    ],
  },
  {
    id: 'campaigns',
    title: '🚀 Как настроить рассылку в Mailora',
    blocks: [
      {
        heading: 'Пошаговый запуск',
        list: [
          'Шаг 1. Подключите SMTP-почты: раздел «Почты».',
          'Шаг 2. Загрузите базу контактов: раздел «Каталог баз».',
          'Шаг 3. Перейдите в раздел «Рассылки» → «Создать кампанию».',
          'Шаг 4. Выберите базу контактов и SMTP-аккаунты (можно несколько).',
          'Шаг 5. Напишите тему и текст письма. Используйте переменную {{name}}/{{companyName}}/{{city}} для персонализации.',
          'Шаг 6. Настройте цепочку: добавьте 2–3 письма с задержкой 3–5 дней.',
          'Шаг 7. Запустите. Статус и статистика — в дашборде.',
        ],
      },
      {
        heading: 'Как следить за результатом',
        list: [
          'Дашборд: отправлено, ответов.',
          'Переписки: все ответы собираются в единый инбокс.',
        ],
      },
      {
        heading: 'Безопасный режим отправки',
        list: [
          '5–10-20 писем в день на один ящик в первые 2 недели.',
          'Не запускайте кампанию на 1000+ писем сразу.',
          'Если получили жалобу — сразу удалите контакт из базы.',
        ],
      },
    ],
  },
];

export default function HelpPage() {
  const [activeSection, setActiveSection] = useState(SECTIONS[0].id);
  const activeData = SECTIONS.find(s => s.id === activeSection) || SECTIONS[0];

  return (
    <div className="min-h-screen bg-gray-50 text-gray-900 flex flex-col">

        <main className="w-full px-3 md:px-4 py-6 md:py-10">

        {/* Заголовок */}
        <div className="mb-6 md:mb-8">
          <h1 className="text-2xl md:text-4xl font-bold">
            📚 Инструкция
          </h1>
          <p className="mt-2 md:mt-3 text-sm md:text-base text-gray-600">
            Как подключить почты, где взять контакты, как писать письма и запустить рассылку.
          </p>
        </div>

        {/* Мобильное меню — горизонтальные чипсы */}
        <div className="md:hidden mb-4 -mx-3 px-3">
          <div className="flex gap-2 overflow-x-auto pb-2 -mb-2">
            {SECTIONS.map((s) => (
              <button
                key={s.id}
                onClick={() => setActiveSection(s.id)}
                className={`flex-shrink-0 px-3 py-2 rounded-full text-xs font-medium whitespace-nowrap transition ${
                  activeSection === s.id
                    ? 'bg-blue-600 text-white shadow-sm'
                    : 'bg-white text-gray-700 border border-gray-200'
                }`}
              >
                {s.title}
              </button>
            ))}
          </div>
        </div>

        {/* Desktop: 2 колонки, Mobile: 1 колонка */}
        <div className="grid md:grid-cols-[260px_1fr] gap-4 md:gap-6">

          {/* Desktop: боковое меню */}
          <aside className="hidden md:block bg-white rounded-2xl shadow-md p-2 h-fit md:sticky md:top-20">
            {SECTIONS.map((s) => (
              <button
                key={s.id}
                onClick={() => {
                  setActiveSection(s.id);
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
                className={`w-full text-left px-3 py-3 rounded-xl text-[14.5px] transition mb-1 ${
                  activeSection === s.id
                    ? 'bg-blue-50 text-blue-700 font-medium border-2 border-blue-500'
                    : 'text-gray-600 hover:bg-gray-100 border-2 border-transparent'
                }`}
              >
                {s.title}
              </button>
            ))}
          </aside>

          {/* Содержимое */}
          <div className="bg-white rounded-2xl shadow-md p-4 md:p-8">
            <h2 className="text-xl md:text-2xl font-bold mb-4 md:mb-6">
              {activeData.title}
            </h2>

            {activeData.blocks.map((b, i) => (
              <div key={i} className="mb-6 md:mb-8 last:mb-0">
                <h3 className="text-base md:text-lg font-semibold mb-2 md:mb-3">
                  {b.heading}
                </h3>
                {b.text && (
                  <p className="text-sm md:text-[15px] text-gray-600 leading-relaxed">
                    {b.text}
                  </p>
                )}
                {b.list && (
                  <ul className="space-y-2">
                    {b.list.map((item, j) => (
                      <li key={j} className="text-sm md:text-[15px] text-gray-700 pl-4 md:pl-5 relative">
                        <span className="absolute left-0 text-blue-600">•</span>
                        {item}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}